<div class="crc-main-outer-card h-100 card" style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden;" *ngIf="crcData">
  <div class="card-header py-2 px-3 text-white font-weight-bold" style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-chart-line mr-1"></i> CRIF / Bureau Details
  </div>

  <div class="p-3" style="background: #ffffff;">
    <div class="crc-simple-card mb-3" *ngFor="let crc of crcData; let i = index" style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #fafbfc;">
      <div class="px-3 py-1 bg-light border-bottom d-flex justify-content-between align-items-center">
        <span class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ crc["Value"] || 'Bureau Record #' + (i + 1) }}</span>
        <span class="badge badge-success px-2 py-1" *ngIf="crc['CRC_CreditVisionScore'] > 650">Score: {{ crc["CRC_CreditVisionScore"] }}</span>
        <span class="badge badge-warning px-2 py-1" *ngIf="crc['CRC_CreditVisionScore'] <= 650 && crc['CRC_CreditVisionScore'] > 0">Score: {{ crc["CRC_CreditVisionScore"] }}</span>
      </div>

      <div class="p-2">
        <div class="row m-0">
          <div class="col-6 p-1">
            <div class="p-2 rounded bg-white border">
              <div class="small text-muted font-weight-bold text-uppercase" style="font-size: 0.65rem;">CreditVision Score</div>
              <div class="font-weight-bold text-primary" style="font-size: 0.9375rem;">{{ crc["CRC_CreditVisionScore"] || 'N/A' }}</div>
            </div>
          </div>
          <div class="col-6 p-1">
            <div class="p-2 rounded bg-white border">
              <div class="small text-muted font-weight-bold text-uppercase" style="font-size: 0.65rem;">Personal Loan Score</div>
              <div class="font-weight-bold text-dark" style="font-size: 0.9375rem;">{{ crc["CRC_PersonalLoanScore"] || 'N/A' }}</div>
            </div>
          </div>
        </div>

        <div class="row m-0">
          <div class="col-6 p-1">
            <div class="p-2 rounded bg-white border">
              <div class="small text-muted font-weight-bold text-uppercase" style="font-size: 0.65rem;">Total Accounts</div>
              <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ crc["CRC_TotalAccounts"] || '0' }}</div>
            </div>
          </div>
          <div class="col-6 p-1">
            <div class="p-2 rounded bg-white border">
              <div class="small text-muted font-weight-bold text-uppercase" style="font-size: 0.65rem;">Current Balance</div>
              <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">₹{{ crc["CRC_CurrentBalanceAmount"] || '0' }}</div>
            </div>
          </div>
        </div>

        <div class="row m-0">
          <div class="col-6 p-1">
            <div class="p-2 rounded bg-white border">
              <div class="small text-muted font-weight-bold text-uppercase" style="font-size: 0.65rem;">Overdue Accounts</div>
              <div class="font-weight-bold text-danger" style="font-size: 0.8125rem;">{{ crc["CRC_OverDueAccounts"] || '0' }}</div>
            </div>
          </div>
          <div class="col-6 p-1">
            <div class="p-2 rounded bg-white border">
              <div class="small text-muted font-weight-bold text-uppercase" style="font-size: 0.65rem;">Overdue Amount</div>
              <div class="font-weight-bold text-danger" style="font-size: 0.8125rem;">₹{{ crc["CRC_OverDueAmount"] || '0' }}</div>
            </div>
          </div>
        </div>

        <div class="p-2 mt-1 rounded bg-white border d-flex justify-content-between align-items-center">
          <span class="small font-weight-bold text-muted text-uppercase" style="font-size: 0.65rem;">Bureau Attachment</span>
          <div class="d-flex gap-2">
            <a target="_blank" class="btn btn-sm btn-outline-primary py-0 px-2 font-size-12" *ngIf="crc.isView != 1 && crc.isViewSurepass != 1 && crc.isViewexperianSurepass != 1 && crc.isViewCrifApi != 1" href="{{crcAttachement}}/{{crc.CRC_ReportName}}"> 
              <i class="fas fa-paperclip mr-1"></i> View Report
            </a>
            <button class="btn btn-sm btn-outline-info py-0 px-2 font-size-12" *ngIf="crc.isView == 1" (click)="getCRCThirdDetail(crc)">
              <i class="fas fa-external-link-alt mr-1"></i> Cibil Report
            </button>
            <button class="btn btn-sm btn-outline-info py-0 px-2 font-size-12" *ngIf="crc.isViewSurepass == 1" (click)="getCRCThirdSurePassDetail(crc)">
              <i class="fas fa-external-link-alt mr-1"></i> Surepass Report
            </button>
            <button class="btn btn-sm btn-outline-info py-0 px-2 font-size-12" *ngIf="crc.isViewexperianSurepass == 1" (click)="getCRCThirdexperianSurepassDetail(crc)">
              <i class="fas fa-external-link-alt mr-1"></i> Experian Report
            </button>
            <a class="btn btn-sm btn-outline-primary py-0 px-2 font-size-12" *ngIf="crc.isViewCrifApi == 1" href="{{crcAttachement}}/{{crc.CRC_ReportName}}" target="_blank">
              <i class="fas fa-paperclip mr-1"></i> View CRIF API
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf="!crcData || crcData.length === 0" class="text-center p-4 bg-light rounded text-muted">
  <i class="fas fa-info-circle mr-1"></i> No Credit Bureau Information Available!
</div>

<!-- Modal Dialogs preserved with nested-modal event safety -->
<div class="modal fade in"
     id="cibilReportmain{{ index }}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">Cibil Report</h6>
        <button type="button" (click)="onCloseCibilmainReport($event)" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="font-size: 0.625rem">
        <ng-container *ngIf="cibilResponseMain">
          <app-quickloan-cibil-report [cibilResponse]="cibilResponseMain"></app-quickloan-cibil-report>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in"
     id="experianReport{{ index }}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">Experian Report</h6>
        <button type="button" (click)="onCloseExperianReportModel($event)" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="font-size: 0.625rem">
        <ng-container *ngIf="experianResponse">
          <app-quickloan-experian-report [experianResponse]="experianResponse"></app-quickloan-experian-report>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in"
     id="cibilReportSurePass{{ index }}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">Cibil Report</h6>
        <button type="button" (click)="onClosecibilReportSurePass($event)" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="font-size: 0.625rem">
        <ng-container *ngIf="cibilResponseSurePass">
          <app-quickloan-cibil-surepass [cibilResponseSurePass]="cibilResponseSurePass"></app-quickloan-cibil-surepass>
        </ng-container>
      </div>
    </div>
  </div>
</div>
